'use client';
import { HeadersInitializationError } from '../../../domain/errors/HeadersInitializationError.js';

const createSafeHeaders = (source)=>{
    try {
        return new globalThis.Headers(source);
    } catch (error) {
        throw new HeadersInitializationError(error);
    }
};

export { createSafeHeaders };
//# sourceMappingURL=createSafeHeaders.js.map
